import { isMaterialWithGas, } from "./articleeditdata";
import { isInstanceOf, } from "./aux";
import { isArray, isString, thicknessEquivalence, } from "./wsi4_typeguards";
export function isLaserMaterialMapEntry(t) {
    const typeGuardMap = {
        laserMaterial: isString,
        materials: (arg) => isArray(arg, isMaterialWithGas),
    };
    return isInstanceOf(t, typeGuardMap);
}
function sortLaserMaterialMap(map) {
    return map.sort((a, b) => a.laserMaterial.localeCompare(b.laserMaterial))
        .map(entry => ({
        laserMaterial: entry.laserMaterial,
        materials: entry.materials.sort((a, b) => a.material.name === b.material.name ? a.cuttingGasId.localeCompare(b.cuttingGasId) : a.material.name.localeCompare(b.material.name)),
    }));
}
function separateMaterialGroup(materialName) {
    const regResult = materialName.match(/(\S+)\s*(.*)/u);
    if (regResult === null || regResult.length !== 3 || regResult[0] !== materialName || regResult[1] === "") {
        console.info("Regex wrong");
        return [
            materialName,
            materialName,
            "",
        ];
    }
    return [
        regResult[0],
        regResult[1],
        regResult[2],
    ];
}
export function laserMaterialMap(configuration, invalid) {
    return sortLaserMaterialMap(configuration.allowedCuttingGasConfigurations
        .filter((config, index, self) => self.findIndex(c => c.sheetMaterial.identifier === config.sheetMaterial.identifier && c.cuttingGasId === config.cuttingGasId) === index)
        .map(config => {
        const material = {
            material: config.sheetMaterial,
            cuttingGasId: config.cuttingGasId,
            invalid: false,
        };
        material.invalid = invalid(material);
        return material;
    })
        .reduce((m, materialWithGas) => {
        const regResult = separateMaterialGroup(materialWithGas.material.name);
        const id = regResult[1];
        const index = m.findIndex(entry => entry.laserMaterial === id);
        if (index === -1) {
            m.push({
                laserMaterial: id,
                materials: [materialWithGas],
            });
        }
        else {
            m[index].materials.push(materialWithGas);
        }
        return m;
    }, []));
}
export function createMaterialString(materialName, cuttingGasId, i18n) {
    const regResult = separateMaterialGroup(materialName);
    const name = regResult[2] === "" ? regResult[1] : regResult[2];
    return name + (cuttingGasId === "N2" ? " (" + i18n.t("cuttingGas") + ")" : "");
}
export function createString(m, i18n) {
    return createMaterialString(m.material.name, m.cuttingGasId, i18n);
}
export function isValid(config, thicknesses, materialId, cuttingGasId) {
    const conf = config.allowedCuttingGasConfigurations.filter(c => c.sheetMaterial.identifier === materialId && c.cuttingGasId === cuttingGasId);
    return thicknesses.every(t => conf.some(c => thicknessEquivalence(t, c.thickness)));
}
